import { setRpcRequestHeadersProvider } from '@repo/rpc-codegen/interceptors'
import { getWorkspaceId } from '@repo/studio-hooks-auth/use-workspace-query'
import { getDashboardRequestTeamId } from '@repo/studio-routes-team/lib/dashboard-request-headers'
import { supportedLanguages } from 'cf-i18n/constants'

setRpcRequestHeadersProvider(() => {
  if (typeof window === 'undefined') {
    return undefined
  }

  const segments = window.location.pathname.split('/').filter(Boolean)
  if (supportedLanguages.some(locale => locale === segments[0])) {
    segments.shift()
  }
  const teamId = segments[0] === 'team' ? getDashboardRequestTeamId() : getWorkspaceId()
  return teamId ? { 'x-team-id': teamId } : undefined
})
